import TabBarLayout from './TabBarLayout';

export default TabBarLayout;
